export const LOGIN_LOADING = "login/signin/loading";
export const LOGIN_SUCCESS = "login/signin/success";
export const LOGIN_ERROR = "login/signin/error";
export const SIGN_OUT = "login/signout";

 
